// @flow

import { zoneActions } from './zoneActionCreator';

const initialState = {
  zoneDetails: {
    isLoading: false,
    isLoaded: false,
    data: null
  }
};

const zoneReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case zoneActions.UPDATE_ZONE_DETAILS: {
      return Object.assign({}, state, { zoneDetails: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default zoneReducer;
